import { apiClient } from './client';

export interface CheckoutResponse {
  sessionId: string;
  url: string;
}

export interface PortalResponse {
  url: string;
}

export interface PricesResponse {
  monthly: string | null;
  yearly: string | null;
  amountMonthly: number;
  amountYearly: number;
}

export interface SubscriptionStatusResponse {
  hasSubscription: boolean;
  status: string | null;
  plan: string | null;
  trialEndsAt: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  trialUsed: boolean;
}

export interface SubscriptionEventData {
  type: 'connected' | 'subscription_updated';
  subscription?: {
    status: string;
    plan: string;
    currentPeriodEnd: string | null;
    trialEnd: string | null;
  };
}

export const billingApi = {
  /**
   * Create Stripe Checkout session
   */
  createCheckout: async (priceId: string, locale?: string): Promise<CheckoutResponse> => {
    const response = await apiClient.post<CheckoutResponse>('/billing/checkout', {
      priceId,
      locale,
    });
    return response.data;
  },

  /**
   * Create Stripe Customer Portal session
   */
  createPortal: async (locale?: string): Promise<PortalResponse> => {
    const response = await apiClient.post<PortalResponse>('/billing/portal', { locale });
    return response.data;
  },

  /**
   * Start 7-day trial
   */
  startTrial: async (): Promise<void> => {
    await apiClient.post('/billing/start-trial');
  },

  /**
   * Get available price IDs
   */
  getPrices: async (): Promise<PricesResponse> => {
    const response = await apiClient.get<PricesResponse>('/billing/prices');
    return response.data;
  },

  /**
   * Get current subscription status
   */
  getStatus: async (): Promise<SubscriptionStatusResponse> => {
    const response = await apiClient.get<SubscriptionStatusResponse>('/billing/status');
    return response.data;
  },
};
